import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { AnyPlayerStatsIcon } from 'components/player/AnyPlayerStatsIcon';

import type { TokenStatsIcon_anyCard } from './__generated__/index.graphql';

type Props = {
  card: TokenStatsIcon_anyCard;
  onInfoClick?: () => void;
};

export const TokenStatsIcon = ({ card, onInfoClick }: Props) => {
  return <AnyPlayerStatsIcon player={card.anyPlayer} onClick={onInfoClick} />;
};

TokenStatsIcon.fragments = {
  anyCard: gql`
    fragment TokenStatsIcon_anyCard on AnyCardInterface {
      slug
      anyPlayer {
        slug
        ...AnyPlayerStatsIcon_anyPlayer
      }
    }
    ${AnyPlayerStatsIcon.fragments.anyPlayer}
  ` as TypedDocumentNode<TokenStatsIcon_anyCard>,
};
